import gql from 'graphql-tag'

export const chapterFragments = {
  chapter: gql`
    fragment chapter on Chapter {
      id
      text
      name
      createdAt
      updatedAt
      featuredMediaObject {
        id
        contentUrl
      }
      place {
        id
        name
        latitude
        longitude
        radius
      }
      story {
        id
      }
      chapterConnectors {
        id
        toChapter {
          id
          name
        }
      }
      chapterConnectorsTo {
        id
        fromChapter {
          id
          name
        }
      }
    }
  `,
  newPlace: gql`
  fragment NewPlace on Place {
    id
    name
    latitude
    longitude
    radius
  }
  `,
  newChapter: gql`
    fragment NewChapter on Chapter {
      id
    }
  `,
  newChapterConnector: gql`
    fragment NewChapterConnector on ChapterConnector {
      id
      toChapter {
        id
        name
      }
      fromChapter {
        id
        name
      }
    }
  `,
}

export const chapterQueries = {
  createChapter: gql`mutation CreateChapter(
    $story: String!
    $name: String!
  ){
    createChapter(input:{
      story: $story
      name: $name
    }) {
      chapter {
        ...chapter
      }
    }
  }
  ${chapterFragments.chapter}
  `,
  getChapters: gql`query GetChapters($storyId: String) {
    chapters(story: $storyId) {
      ...chapter
    }
  }
  ${chapterFragments.chapter}
  `,
  updateChapterName: gql`mutation UpdateChapterName($chapterId: ID!, $name: String) {
    updateChapter(input: { id: $chapterId, name: $name }) {
      chapter {
        ...chapter
      }
    }
  }
  ${chapterFragments.chapter}
  `,
  updateChapterText: gql`mutation UpdateChapterName($chapterId: ID!, $text: String) {
    updateChapter(input: { id: $chapterId, text: $text }) {
      chapter {
        ...chapter
      }
    }
  }
  ${chapterFragments.chapter}
  `,
  updateChapterConnector: gql` mutation UpdateChapterConnector($chapterConnectorId: ID!, $toChapterId: String) {
    updateChapterConnector(input: {id: $chapterConnectorId, toChapter: $toChapterId}) {
      chapterConnector {
        id
        toChapter {
          id
          name
        }
      }
    }
  }`,
  getChapterWithFeaturedMediaObject: gql`query GetChapterWithFeaturedMediaObject($id: ID!) {
    chapter(id: $id) {
      id
      featuredMediaObject {
        id
        contentUrl
      }
    }
  }`,
  createChapterConnector: gql` mutation CreateChapterConnector($fromChapterId: String) {
    createChapterConnector(input: {fromChapter: $fromChapterId}) {
      chapterConnector {
        ...NewChapterConnector
      }
    }
  }
  ${chapterFragments.newChapterConnector}
  `,
  deleteChapterConnector: gql` mutation DeleteChapterConnector($chapterConnectorId: ID!) {
    deleteChapterConnector(input: {id: $chapterConnectorId}) {
      chapterConnector {
        id
      }
    }
  }`,
  deleteChapter: gql` mutation DeleteChapter($chapterId: ID!) {
    deleteChapter(input: {id: $chapterId}) {
      chapter {
        id
      }
    }
  }`,
  updateChapterPlace: gql` mutation updateChapterPlace(
    $chapterId: ID!,
    $latitude: Float!,
    $longitude: Float!,
    $name: String,
    $radius: Int!) {
    createOrUpdatePlaceChapter(
      input: {
        id: $chapterId
        latitude: $latitude
        longitude: $longitude
        radius: $radius
        placeName: $name
      }) {
        chapter {
          id
          place {
            id
            latitude
            longitude
            radius
            name
          }
        }
    }
  }`,
  createPlace: gql`mutation createPlace(
    $latitude: float!,
    $longitude: float!,
    $radius: int!) {
    createPlace(
      input: {
        latitude: $latitude,
        longitude: $longitude,
        radius: $radius
      }) {
      place {
        ...newPlace
      }
    }
  }
  ${chapterFragments.newPlace}
  `,
}